import { render, staticRenderFns } from "./Template49.vue?vue&type=template&id=618a3838&scoped=true&"
import script from "./Template49.vue?vue&type=script&lang=js&"
export * from "./Template49.vue?vue&type=script&lang=js&"
import style0 from "./Template49.vue?vue&type=style&index=0&id=618a3838&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618a3838",
  null
  
)

export default component.exports